<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold">“They challenge, shape, and improve it.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This reflects <span class="font-bold"
        >deep trust and psychological safety.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Your team feels ownership, not just obligation - they know that pushing
      back is part of contributing, not dissenting.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a Fast Attack sub, even the most junior officer can question the
      mission approach - because the goal isn’t obedience, it’s excellence.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Protect this culture fiercely. Ask: <span class="italic"
        >Are we building this habit into all levels of the team, or just
        leadership?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Create space in meetings for “challenge rounds” - where refining ideas is
      the expectation, not the exception.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“They listen, nod, and ask what to do.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This signals <span class="font-bold"
        >polite compliance, not shared conviction.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Your team may respect your ideas - but they don’t feel empowered or safe
      enough to shape them.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack crews don’t just nod. They engage, analyze, and adapt. Quiet
      rooms aren’t aligned - they’re unclear.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Explicitly invite critique. Say: <span class="italic"
        >“What am I missing?”</span
      >
      or <span class="italic">“Who sees this differently?”</span>
    </p>
    <p class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Normalize challenge, especially in moments where it feels uncomfortable to
      speak up.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“They say yes - but don’t act.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is <span class="font-bold"
        >false alignment - a lack of trust in follow-through or safety in
        raising doubts.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      They’re saying yes to you, but not yes to the work.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      In elite teams, nodding without action is a silent breakdown. It shows
      people don’t feel safe enough to commit - or push back honestly.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic">Why didn’t we move on this? </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Then create a system where team members can signal hesitations early -
      without fear of looking like blockers.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold"
        >“They seem nervous about getting it wrong.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This points to a <span class="font-bold">fear-based environment,</span> even
      if unintentional.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People aren’t afraid of the work - they’re afraid of disappointing you or
      making a visible misstep.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a sub, hesitation under pressure is dangerous. Confidence is built
      through repetition, clarity, and permission to fail fast.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Start a “safe to test” habit. Assign ideas to small trial runs or pilots.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Make it clear that action - even imperfect action - is more valuable than
      playing it safe.
    </p>
  {/if}
</div>
